type CookieApprove = {
	submitted: boolean;
	value: boolean;
};

const getDefault = (): CookieApprove => {
	return { submitted: false, value: false };
};

export function useCookieApprove() {
	const st = useLocalStorage(['cookie']);

	const cookieValue = computed(() => {
		return st.storage.value?.cookie?.length ? JSON.parse(st.storage.value.cookie) : getDefault();
	});

	function submit() {
		const value: CookieApprove = { submitted: true, value: true };

		st.storage.value = { cookie: JSON.stringify(value) };
	}

	return { cookieValue, submit };
}
